/**
 * Supplier product equivalence: (partyId + supplierCode) → productId.
 * Logical path: org/{orgId}/supplier-product-map
 *
 * Technical mapping — Auditable only, no Inactivatable.
 */
export const SUPPLIER_PRODUCT_MAP = 'SupplierProductMap';
//# sourceMappingURL=supplier-product-map.js.map